import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Icon, Typography, VisuallyHidden, } from '@zapier/design-system';
const Styles = labelStyles('SearchTogglerInApp', {
    root: css `
    height: 40px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    gap: 5px;
    margin-right: 10px;
    justify-content: center;
    color: ${Colors.neutral800};

    &:hover,
    &:focus {
      background-color: transparent;
      color: ${Colors.neutral800};
      ${Typography.paragraph3Bold};
    }
  `,
});
const SearchToggler = (props) => {
    return (isolateComponent("label", { css: Styles.root, htmlFor: props.id },
        isolateComponent(Icon, { name: props.isSearching ? 'formX' : 'magnifyingGlass', size: 24 }),
        props.size !== 'small' ? ('Search') : (isolateComponent(VisuallyHidden, null, "Search"))));
};
export default SearchToggler;
//# sourceMappingURL=SearchToggler.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
